import { httpClient } from '../httpClient';
import {
  IBgm,
  PaginatedResponse,
  BgmQuery,
  PaginationQuery,
  BGM_TYPES,
  IBgmType
} from '@packages/global';

/**
 * 用户背景音乐 API 模块
 * 处理用户背景音乐查询操作
 */
export class BgmApi {
  /**
   * 获取用户背景音乐分页列表（POST，强类型）
   */
  async bgmPageList(queryData: PaginationQuery<BgmQuery>): Promise<PaginatedResponse<IBgm>> {
    return httpClient.post<PaginatedResponse<IBgm>>('/user/bgms/page', queryData);
  }

  /**
   * 获取BGM类型列表（硬编码）
   */
  getBgmTypes(): IBgmType[] {
    return BGM_TYPES;
  }
}

// 导出单例实例
export const bgmApi = new BgmApi();